import { RefObject, useCallback, useMemo, useState } from "react";
import useResizeObserver from "./useResizeObserver";
import { usePointerEnter } from "./usePointerEnter";

export const useDimensions = (on: boolean, ref: RefObject<HTMLDivElement>) => {
  const [width, setWidth] = useState(0);
  const [offset, setOffset] = useState(0);

  const handler = useCallback(() => {
    if (ref.current !== null) {
      const element = ref.current;
      const { width, left } = element.getBoundingClientRect();
      setWidth(width);
      setOffset(left);
    }
  }, [ref]);

  usePointerEnter({ on, ref, callback: handler });
  useResizeObserver(on, ref, handler);

  return useMemo(
    () => ({
      width,
      offset,
    }),
    [offset, width]
  );
};
